<template>
  <q-dialog persistent  v-model="alert" :backdrop-filter="backdropFilter">
      <q-card style="width: 500px; max-width: 80vw;">
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">New Module</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-card-section >
              <q-form @submit.prevent="onSubmitModule">
                <div class="q-pa-md">
                  <q-input
                    color="indigo-10"
                    outlined
                    label="Module"
                    lazy-rules
                     width="48"
                     v-model="name"
                    :rules="[ val => val && val.length > 0 || 'Please type something']">
                  </q-input>
                  <q-input
                    color="indigo-10"
                    outlined
                    label="Description"
                    lazy-rules
                    v-model="description"
                    :rules="[ val => val && val.length > 0 || 'Please type something']">
                  </q-input>
                  <div>
                    <q-btn
                      style="background-color: #010127;"
                      color="white-8"
                      rounded
                      class="full-width q-mr-sm"
                      v-ripple
                      size="lg"
                      clickable
                      :loading="isSubmitted"
                      type="submit"
                      >Save Module
                    </q-btn>
                  </div>
                </div>
              </q-form>
            </q-card-section>
      </q-card>
    </q-dialog>
</template>

<script>
import { useQuasar } from 'quasar'  
import { ref } from 'vue'
import axios from 'axios'
import EventBus from "@/EventBus"

export default {
  
  setup () {
    const token = ref(window.$cookies.get(process.env.VUE_APP_API_KEY).token)
    const $q = useQuasar()
    const backdropFilter = ref('grayscale(100%)')
    const alert = ref(false)
    const isSubmitted = ref(false)
    const courseId = ref(null)
    const name = ref(null)
    const description = ref(null)
    
    EventBus.on("newModuleModal",(val) => {
        alert.value = val.status
        courseId.value = val.courseId
    })

    return {
      token,
      alert,
      backdropFilter,
      isSubmitted,
      courseId,
      name,
      description,

      onSubmitModule () {
        var formData = {
          "course_id":courseId.value.trim(),
          "name":name.value.trim(),
          "description": description.value.trim()
        }
        isSubmitted.value = true; 
        axios.post(process.env.VUE_APP_API_URL + '/module',formData,{
          headers: { 'Authorization': `Bearer ${token.value}`},
        }).then((response) => {
          if(response.data.status){
            isSubmitted.value = false
            alert.value = false
            $q.notify({
              color: 'positive',
              textColor: 'white',
              icon: 'check_circle',
              message: response.data.message
            })
          EventBus.emit("refreshModuleData")
          }else{
            isSubmitted.value = false
            $q.notify({
              color: 'negative',
              textColor: 'white',
              icon: 'warning',
              message: response.data.message
            })
          }
        }).catch((e) => {
           isSubmitted.value = false
           $q.notify({
              color: 'negative',
              textColor: 'white',
              icon: 'warning',
              message: e.response.data.message
            })
        })
      }
    }

  },

}
</script>